import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { useAppDispatch, useAppSelector } from "../../../Hooks/useStore";
import { useCallback } from "react";

export type UserServicesTypes = {
  serviceId: number | string;
  userServiceId: number;
};

export type InitialStateTypes = {
  userServices: UserServicesTypes[];
};

const initialState = {
  userServices: [],
} as InitialStateTypes;

export const userServices = createSlice({
  name: "subService",
  initialState,
  reducers: {
    setUserService: (state, action: PayloadAction<UserServicesTypes>) => {
      const foundUserService = state.userServices.find(
        (userService) => userService.serviceId === action.payload.serviceId,
      );
      if (foundUserService) {
        state.userServices = state.userServices.filter(
          (userService) => userService !== foundUserService,
        );
        state.userServices.push(action.payload);
      } else {
        state.userServices.push(action.payload);
      }
    },
    removeUserService: (state, action: PayloadAction<number>) => {
      const foundUserService = state.userServices.find(
        (userService) => userService.serviceId === action.payload,
      );
      if (foundUserService) {
        state.userServices = state.userServices.filter(
          (userService) => userService !== foundUserService,
        );
      }
    },
  },
});

export type UseUserServiceProps = {
  serviceId?: number;
};

export const useUserServices = (props: UseUserServiceProps) => {
  const { serviceId } = props;
  const dispatch = useAppDispatch();
  const { userServices } = useAppSelector((state) => state.userServices);

  const { userServiceId } =
    userServices?.find((userService) => userService.serviceId === serviceId) ||
    {};

  const dispatchSetUserService = useCallback(
    (data: { serviceId: number; userServiceId: number }) => {
      dispatch(setUserService(data));
    },
    [dispatch],
  );

  const dispatchRemoveUserService = useCallback(() => {
    if (serviceId) {
      dispatch(removeUserService(serviceId));
    }
  }, [dispatch, serviceId]);

  return {
    userServiceId,
    serviceId,
    userServices,
    dispatchRemoveUserService,
    dispatchSetUserService,
  };
};

export const { setUserService, removeUserService } = userServices.actions;
export default userServices.reducer;
